import React from 'react';

class Tooltip extends React.Component {
  render() {
    const { text, children } = this.props;

    if (children) {
      return (
        <span className="dui-tooltip dui-tooltip-top" data-tip={text}>
          {children}
        </span>
      );
    }

    return (
      <span
        className="dui-tooltip dui-tooltip-top cursor-help inline-flex items-center justify-center h-5 w-5 rounded-full text-[10px] font-bold ml-1 align-middle"
        data-tip={text}
        style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
      >
        i
      </span>
    );
  }
}

export default Tooltip;
